import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import CustomerHeader from '../../components/CustomerHeader';
import CustomerFooter from '../../components/CustomerFooter';
import api from '../../lib/api';
import { LoadingBlock } from '../../components/States';
import { Card } from '../../components/ui/card';

const LABELS = {
    terms: { key: 'terms_and_conditions', title: 'Terms & Conditions' },
    privacy: { key: 'privacy_policy', title: 'Privacy Policy' },
    shipping: { key: 'shipping_policy', title: 'Shipping Policy' },
    refund: { key: 'refund_policy', title: 'Refund & Returns Policy' },
};

// Simple markdown-lite renderer (headings, lists, paragraphs)
function MarkdownLite({ text }) {
    if (!text) return null;
    const lines = text.split('\n');
    const out = [];
    let listBuf = [];
    const flush = () => { if (listBuf.length) { out.push(<ul key={out.length} className="list-disc pl-6 space-y-1 mb-3">{listBuf.map((li, i) => <li key={i}>{li}</li>)}</ul>); listBuf = []; } };
    for (let i = 0; i < lines.length; i++) {
        const l = lines[i];
        if (/^#\s+/.test(l)) { flush(); out.push(<h1 key={out.length} className="text-2xl font-bold tracking-tight mt-6 mb-3">{l.replace(/^#\s+/, '')}</h1>); }
        else if (/^##\s+/.test(l)) { flush(); out.push(<h2 key={out.length} className="text-xl font-semibold mt-5 mb-2">{l.replace(/^##\s+/, '')}</h2>); }
        else if (/^###\s+/.test(l)) { flush(); out.push(<h3 key={out.length} className="text-lg font-semibold mt-4 mb-2">{l.replace(/^###\s+/, '')}</h3>); }
        else if (/^-\s+/.test(l)) { listBuf.push(l.replace(/^-\s+/, '')); }
        else if (l.trim() === '') { flush(); }
        else { flush(); out.push(<p key={out.length} className="text-neutral-700 leading-relaxed mb-3">{l}</p>); }
    }
    flush();
    return <div>{out}</div>;
}

export default function Policy() {
    const { kind } = useParams();
    const meta = LABELS[kind] || LABELS.terms;
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get('/business-settings/public').then(r => setSettings(r.data)).finally(() => setLoading(false));
    }, [kind]);
    const content = settings?.[meta.key];
    return (
        <div className="bg-white min-h-screen">
            <CustomerHeader />
            <section className="login-hero-bg text-white">
                <div className="max-w-[900px] mx-auto px-4 py-10">
                    <div className="text-xs text-white/80"><Link to="/" className="hover:underline">Home</Link> / {meta.title}</div>
                    <h1 className="text-3xl sm:text-4xl font-bold mt-2">{meta.title}</h1>
                </div>
            </section>
            <section className="py-10">
                <div className="max-w-[900px] mx-auto px-4">
                    <Card className="p-6 sm:p-8">
                        {loading ? <LoadingBlock /> : content ? <MarkdownLite text={content} /> : <p>Content coming soon.</p>}
                        <div className="mt-6 pt-4 border-t text-xs text-neutral-500">Last updated: {settings?.updated_at ? new Date(settings.updated_at).toLocaleDateString() : new Date().toLocaleDateString()}</div>
                    </Card>
                </div>
            </section>
            <CustomerFooter />
        </div>
    );
}
